var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_visible/on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Styleguide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input-fileds,-dropdowns,-sliders,-and-other-elements",
    transform: "translate(-470, -435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(70, 407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_visible/on",
    transform: "translate(400, 28)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_visible",
    mask: "url(#mask-2)",
    fill: "#738089",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 3)",
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99787557,0 C11.1245451,0 14.0037803,1.75830077 15.8934033,4.82922362 L16,5 L15.8934033,5.17089843 C14.0037803,8.24169921 11.1245451,10 7.99787557,10 C4.87120609,10 1.99197088,8.24169921 0.102347822,5.17089843 L0,5 L0.106596677,4.82922362 C1.99197088,1.75830078 4.87120609,0 7.99787557,0 Z M7.99787557,0.666625994 C5.17412563,0.666625994 2.55932018,2.24169921 0.79766313,4.99999999 C2.55932018,7.75830078 5.17412563,9.33337403 7.99787557,9.33337403 C10.8216255,9.33337403 13.436431,7.75830078 15.198088,4.99999999 C13.436431,2.24169921 10.8216255,0.666625994 7.99787557,0.666625994 Z M7.99787557,1.66662599 C9.87900089,1.66662599 11.4103441,3.16247559 11.4103441,4.99999999 C11.4103441,6.83752443 9.87900089,8.33337402 7.99787557,8.33337402 C6.11675025,8.33337402 4.585407,6.83752443 4.585407,4.99999999 C4.585407,3.16247559 6.11675025,1.66662599 7.99787557,1.66662599 Z M7.99787557,2.33337402 C6.49215054,2.33337402 5.26797571,3.52917481 5.26797571,4.99999999 C5.26797571,6.47082518 6.49215054,7.66662599 7.99787557,7.66662599 C9.50360061,7.66662599 10.7277754,6.47082518 10.7277754,4.99999999 C10.7277754,3.52917481 9.50360061,2.33337402 7.99787557,2.33337402 Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOn);
export default __webpack_public_path__ + "static/media/on.932e69eb245368ff29732dec74d07bab.svg";
export { ForwardRef as ReactComponent };